export const ACCESS_TOKEN_KEY = 'token';
export const SYSTEM_ID = '67b8942d84aa654e8ed2f183'
export const ALBUM_CD_ID = '67ba08fd554710ea60fb5486'
export const ALBUM_USB_ID = '67dffdf8b206836574df3efa'
export const CASH_ON_DELIVERY_ID = '67d9e3406a002cd9d315eb06'
export const PERSON_PICKUP_ID = '67dffd8cb206836574df3ef9'
